"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M14 8A6 6 0 112 8a6 6 0 0112 0zM9 4v2H7V4h2zm0 3v4h1v1H6v-1h1V8H6V7h3z"];
//# sourceMappingURL=small-info-sign.js.map